var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAwa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 66,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  filter: "url(#awa_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M89.492 1.173a1.321 1.321 0 0 0-2.14-.876l-13.236 10.63a1.32 1.32 0 0 0 .327 2.253l3.791 1.551-12.276 29.877L60 34.318c-1.749-3.022-6.183-2.803-7.627.375L44.47 52.098 36.41 34.244a4.13 4.13 0 0 0-7.527 3.394l11.659 25.833c1.519 3.366 6.297 3.371 7.824.01l8.343-18.368 6.136 10.599c1.786 3.083 6.335 2.776 7.69-.52l15.34-37.334 3.779 1.546a1.32 1.32 0 0 0 1.813-1.376zm10.791 50.946-7.055-16.742-7.014 16.742zm3.478 8.254 1.304 3.092a4.13 4.13 0 0 0 7.61-3.204l-15.5-36.781c-1.477-3.506-6.448-3.5-7.918.008l-15.411 36.78a4.13 4.13 0 0 0 7.617 3.188l1.292-3.083zm-78.634 3.09-1.304-3.09H12.231l-1.293 3.082a4.13 4.13 0 0 1-7.616-3.19L14.04 34.707c1.47-3.506 6.439-3.511 7.917-.008l10.78 25.557a4.13 4.13 0 0 1-7.61 3.207M18.01 46.591l2.332 5.528h-4.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#awa_svg__b)",
  d: "M89.492 1.173a1.321 1.321 0 0 0-2.14-.876l-13.236 10.63a1.32 1.32 0 0 0 .327 2.253l3.791 1.551-12.276 29.877L60 34.318c-1.749-3.022-6.183-2.803-7.627.375L44.47 52.098 36.41 34.244a4.13 4.13 0 0 0-7.527 3.394l11.659 25.833c1.519 3.366 6.297 3.371 7.824.01l8.343-18.368 6.136 10.599c1.786 3.083 6.335 2.776 7.69-.52l15.34-37.334 3.779 1.546a1.32 1.32 0 0 0 1.813-1.376zm10.791 50.946-7.055-16.742-7.014 16.742zm3.478 8.254 1.304 3.092a4.13 4.13 0 0 0 7.61-3.204l-15.5-36.781c-1.477-3.506-6.448-3.5-7.918.008l-15.411 36.78a4.13 4.13 0 0 0 7.617 3.188l1.292-3.083zm-78.634 3.09-1.304-3.09H12.231l-1.293 3.082a4.13 4.13 0 0 1-7.616-3.19L14.04 34.707c1.47-3.506 6.439-3.511 7.917-.008l10.78 25.557a4.13 4.13 0 0 1-7.61 3.207M18.01 46.591l2.332 5.528h-4.65z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "awa_svg__b",
  x1: 88.744,
  x2: -28.836,
  y1: -91.704,
  y2: 67.213,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.206,
  stopColor: "#FFF0A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "gold"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.833,
  stopColor: "#FF41F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF33FF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "awa_svg__a",
  width: 116,
  height: 65.996,
  x: 0,
  y: 0.004,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.945663 0 0 0 0 0.704167 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5195_14068"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.998581 0 0 0 0 0.7375 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_5195_14068",
  result: "effect2_dropShadow_5195_14068"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_5195_14068",
  result: "shape"
})))));
export default SvgAwa;